import React, { useRef, useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import ApiService from "../../_services/ApiService";
import { ILoader } from "../../_components/iloader/iloader";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import Config from "../../_config/config";
// import "./admit-card-anima.styles.css";

import AdmitCard from "../AdmitCard"
import Row2 from "../Row2";
import Column2 from "../Column2";
import Row4 from "../Row4";
// import "../AdmitCard/AdmitCard.css";
const ADMITCARD_DETAILS = [{ copy: null }]; //{ copy: "OFFICE COPY" }



const AdmitCardAnima = () => {


//set formal values 

  const history = useHistory();
  const { getCenterAdressById } = useContext(AppPropertiesContext);
  const location = useLocation();
  const { state } = location;
  const { testDetails, testTime, testName, centreName, centreAddress } =
    state || {};
  const timesArr  = testTime.split(" ");
  //getdayName 
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var d = new Date(timesArr[0]);
  var dayName = days[d.getDay()-1];
  const [fetchedAdmitCardDetails, setAdmitCardDetails] = useState({});

  const centreAddressById = getCenterAdressById(
    fetchedAdmitCardDetails?.jsonField1
      ? fetchedAdmitCardDetails?.jsonField1["form-id"]
      : null,
    fetchedAdmitCardDetails?.jsonField1?.centreId
  );

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const fetchAdmitCardDetails = async () => {
      if (testDetails) return;
      setShowLoader(true);
      const res = await ApiService.fetchAdmitCardDetails();
      const newAdmitCardDetails = res.data;
      console.log(newAdmitCardDetails);
      setShowLoader(false);
      setAdmitCardDetails(newAdmitCardDetails);
    };

    fetchAdmitCardDetails();
  }, []);

  const admitCardDetails = ADMITCARD_DETAILS;
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(user);

  const container = useRef(null);
  useEffect(() => {
    if (container) {
      // window.print();
    }
  }, []);

  const printAdmitCard = () => {
    window.print();
  };

//end 
const row21Data = {
    nameOfTheCandidate: "Name of the Candidate",
    rajendraKumar: fetchedAdmitCardDetails?.jsonField1?.studentName ||
                      user?.username,
    surname: "Day",
    saturday: dayName,
};

const row22Data = {
    nameOfTheCandidate: "Test Details",
    rajendraKumar: testName,
    surname: "Time",
    saturday:timesArr[1]+" "+timesArr[2] ,
};

const column21Data = {
    children: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
};

const column22Data = {
    children: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
};

const column23Data = {
    children: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
};

const column24Data = {
    children: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.",
};

const row41Data = {
    text4: "4.There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.",
    column2Props: column24Data,
};

const column25Data = {
    children: "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
};

const row42Data = {
    text4: "5.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    column2Props: column25Data,
};

const column26Data = {
    children: "Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
};

const row43Data = {
    text4: "6.Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
    column2Props: column26Data,
};
console.log("td start");
console.log(dayName);
console.log('td end');
const admitCardData = {
    image5: "/img/image-5.png",
    title: "Admit Card",
    admitCardNo: "Admit Card No.",
    number: fetchedAdmitCardDetails?.studentCode ||
                      testDetails?.AdmitCardNumber,
    place1: "Date",
    address: timesArr[0],
    examinationCenter: "Examination Center",
    centerName: "Center Name:",
    place2: centreName,
    centerAddress: "Center Address:",
    unacademyPlotNo:centreAddress,// <React.Fragment></React.Fragment>,
    instructionsToTheCandidate: "Instructions to the Candidate",
    text1: "1. Student need to print and carry the Admit card to the exam centre.",
    text2: "2. Student will not be allowed to appear in the exam without admit card",
    text3: "3. Student should report the examination centre 30 minutes before the exam start time",
    row21Props: row21Data,
    row22Props: row22Data,
    column21Props: column21Data,
    column22Props: column22Data,
    column23Props: column23Data,
    row41Props: row41Data,
    row42Props: row42Data,
    row43Props: row43Data,
};




  return (
    <>
      <AdmitCard {...admitCardData} />
    </>
  );
};

export default AdmitCardAnima;
